export enum CustomInventoryNavigationType {
  Devices = "devices",
  Parts = "parts",
}
